import { ActiveExperiments } from '../AbTestingRegistry';
import { TestingVariant } from '../AbTestingTypes';

const STORAGE_KEY_PREFIX = 'dac_ab_test_';

function getStoredVariant(experimentName: string): string | null {
	try {
		return localStorage.getItem(`${STORAGE_KEY_PREFIX}${experimentName}`);
	} catch {
		return null;
	}
}

function storeVariant(experimentName: string, variantName: string): void {
	try {
		localStorage.setItem(`${STORAGE_KEY_PREFIX}${experimentName}`, variantName);
	} catch {
		// Ignore storage errors
	}
}

export function establishTestingVariant(): TestingVariant | null {
	// Currently, we support selecting one active experiment. 
	// In a more complex setup, we might have multiple active experiments running simultaneously.
	// For now, we'll process the first active experiment in the registry.
	
	const experiment = ActiveExperiments[0];
	if (!experiment) {
		return null;
	}

	const storedVariantName = getStoredVariant(experiment.name);

	if (storedVariantName) {
		const existingVariant = experiment.variants.find(v => v.variant.name === storedVariantName);
		if (existingVariant) {
			return existingVariant.variant;
		}
	}

	// Roll the dice
	const random = Math.random();
	let cumulativeWeight = 0;

	for (const { variant, weight } of experiment.variants) {
		cumulativeWeight += weight;
		if (random < cumulativeWeight) {
			storeVariant(experiment.name, variant.name);
			return variant;
		}
	}

	// Fallback to the last variant if something goes wrong with weights
	const lastVariant = experiment.variants[experiment.variants.length - 1].variant;
	storeVariant(experiment.name, lastVariant.name);
	return lastVariant;
}



